"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var FormRowWithinContext_1 = require("./FormRowWithinContext");
/**
 * The `FormRow` component groups one or more form elements into a logical
 * group with its own label, as well as optional tooltip, error message and
 * description.
 *
 * The component takes care of semantic markup and thus of accessibility:
 * * If it contains only one form element, a div with a label is created for the
 *   form element.
 * * If it contains several form elements, a div with role="group" is
 *   created. In this case, each form element needs an `aria-label` attribute for
 *   accessibility. This attribute is left to be defined by the users of the
 *   component.
 */
exports.FormRow = withContext_1.withErgoElementsContext('FormRow', FormRowWithinContext_1.FormRowWithinContext);
exports.default = exports.FormRow;
__export(require("./FormRowWithinContext"));
//# sourceMappingURL=FormRow.js.map